import { render, staticRenderFns } from "./component.vue?vue&type=template&id=7cf22d10&scoped=true&"
import script from "./component.vue?vue&type=script&lang=js&"
export * from "./component.vue?vue&type=script&lang=js&"
import style0 from "./component.scss?vue&type=style&index=0&id=7cf22d10&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf22d10",
  null
  
)

export default component.exports